import { render, staticRenderFns } from "./OrganizStudentList.vue?vue&type=template&id=622e5c2c&scoped=true&"
import script from "./OrganizStudentList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizStudentList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizStudentList.vue?vue&type=style&index=0&id=622e5c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622e5c2c",
  null
  
)

export default component.exports